import * as initialStateConstant from "./initialStateConstant";

export const initialState = {
    loader: false,
    startApp: false,
    user: initialStateConstant.USER_INITIAL,
    debt: '',
    sidebar: false,
    search: '',
    currentVisitors: [],
    establishmentList: [],
    currentEstablishment: '',
    users: [],
    usersList: [],
    currentUser: initialStateConstant.CURRENT_USER_INITIAL,
    usersStats: {
        active_subscriptions: 0,
        inactive_subscriptions: 0,
        subscriptions_count: 0,
        users_count: 0,
        male: 0,
        female: 0,
        workouts_run: 0,
        workouts_done: 0,
        types: []
    },
    statistic: {},
    statistic_dates: initialStateConstant.STATISTIC_DATES_INITIAL,
    subscriptions: {},
    all_subscriptions_count: '',
    subscriptions_active_only: false,
    subscriptions_inactive_only: false,
    context: null,
    subscriptionForm: initialStateConstant.SUBSCRIPTION_FORM_INITIAL,
    dropdown: null,
    subscriptionCalendar: initialStateConstant.SUBSCRIPTION_CALENDAR_INITIAL,
    extend_subscription_form: initialStateConstant.EXTEND_SUBSCRIPTION_FORM_INITIAL,
    userForm: initialStateConstant.USER_FORM_INITIAL,
    addSubscriptionForm: initialStateConstant.ADD_SUBSCRIPTION_FORM_INITIAL,
    subscription_coaches: [],
    subscription_types: [],
    subscription_durations: [],
    subscription_constraints: [],
    subscription_workouts_count: [],
    settings_tab: 'establishment',
    typeOpenSettingsForm: '',
    subscription_type_form: initialStateConstant.SUBSCRIPTION_TYPE_FORM_INITIAL,
    subscription_duration_form: initialStateConstant.SUBSCRIPTION_DURATION_FORM_INITIAL,
    subscription_workouts_form: {
        id: '',
        name: '',
        count: 0,
        unlim: '0',
        establishments: []
    },
    subscription_constraint_form: initialStateConstant.SUBSCRIPTION_CONSTRAINT_FORM_INITIAL,
    photo_file: null,
    watch_photo: '',
    qr_data: {
        link: '',
        logo: '',
        color: ''
    },
    notifications_form: initialStateConstant.PUSH_NOTIFICATION_FORM_INITIAL,
    key_number: initialStateConstant.KEY_NUMBER_FORM_INITIAL,
    monitor_view: 'tile',
    current_subscription: initialStateConstant.CURRENT_SUBSCRIPTION_INITIAL,
    promo: [],
    promo_form: initialStateConstant.PROMO_FORM_INITIAL,
    promo_goods_form: initialStateConstant.PROMO_GOODS_FORM_INITIAL,
    price: [],
    price_form: initialStateConstant.PRICE_FORM_INITIAL,
    sort: {
        table: '',
        field: '',
        order: ''
    },
    workouts: [],
    all_workouts_count: '',
    pagination: {
        first: 0,
        prev: 0,
        current: 0,
        next: 0,
        last: 0
    },
    filterDate: {
        from: '',
        to: ''
    },
    coach_form: initialStateConstant.COACH_FORM_INITIAL,
    coaches: [],
    oneTimeWorkoutForm: initialStateConstant.ONE_TIME_WORKOUT_FORM_INITIAL,
    sales: [],
    all_sales_count: '',
    total_sum: '',
    filterUser: {
        user: { id: '', name: '' },
        users: []
    },
    payment_methods_form: initialStateConstant.PAYMENT_METHODS_FORM_INITIAL,
    payment_methods: [],
    calendar: initialStateConstant.CALENDAR_INITIAL,
    paymentForm: initialStateConstant.PAYMENT_FORM_INITIAL,
    repay_money_form: {
        open: false,
        subscription_id: '',
        sum: '',
        payment_method: { id: '', name: '' }
    },
    firstCurrentVisitorsRequest: false,
    booking: {
        date: '',
        yesterday: '',
        tomorrow: '',
        schedule: [],
        types: [],
        reserves: []
    },
    bookingForm: initialStateConstant.BOOKING_FORM_INITIAL,
    booking_users_form: initialStateConstant.BOOKING_USERS_FORM_INITIAL,
    subscription_inactive_days: '0',
    filterTypesOptions: [],
    filterCoachesOptions: [],
    filterConstraintsOptions: [],
    filterWorkoutsCountOptions: [],
    filterSubjectOptions: [
        { id: '1', name: 'Абонементы', active: false },
        { id: '2', name: 'Разовые занятия', active: false },
        { id: '3', name: 'Товары', active: false },
        { id: '4', name: 'Депозиты', active: false }
    ],
    filterPaymentMethodsOptions: [],
    filterAdminsOptions: [],
    filterMinSum: '',
    filterMaxSum: '',
    familyForm: initialStateConstant.FAMILY_FORM_INITIAL,
    discount: [],
    discountForm: {
        id: '',
        name: '',
        percent: '',
        establishments: []
    },
    gifts: [],
    giftForm: initialStateConstant.GIFT_FORM_INITIAL,
    giftsOrders: [],
    giftsStatusFilterOptions: [
        { id: 'pending', name: 'Ожидает подтверждения', active: false },
        { id: 'accepted', name: 'Выполнен', active: false },
        { id: 'rejected', name: 'Отклонён', active: false }
    ],
    goodsForm: initialStateConstant.GOODS_FORM_INITIAL,
    goods: [],
    groupForm: initialStateConstant.GROUP_FORM_INITIAL,
    groups: [],
    storeForm: initialStateConstant.STORE_FORM_INITIAL,
    filterOneTimeWorkout: '0',
    filterDebtWorkouts: '0',
    weekBooking: initialStateConstant.WEEK_BOOKING_INITIAL,
    filterWindow: false,
    filterUsers: initialStateConstant.FILTER_USERS_INITIAL,
    select: initialStateConstant.SELECT_INITIAL,
    tasks: [],
    task_form: initialStateConstant.TASK_FORM_INITIAL,
    task_archive: false,
    tasks_count: '',
    transferUserDataForm: initialStateConstant.TRANSFER_USER_DATA_FORM_INITIAL,
    user_permission: initialStateConstant.USER_PERMISSION_FORM_INITIAL,
    bookingNotificationForm: initialStateConstant.BOOKING_NOTIFICATION_FORM_INITIAL,
    messages: [],
    admins: [],
    removeDebt: initialStateConstant.REMOVE_DEBT_INITIAL,
    docs: [],
    upload_file: initialStateConstant.UPLOAD_FILE_INITIAL,
    automation: initialStateConstant.AUTOMATION_INITIAL,
    admin_form: initialStateConstant.ADMIN_FORM_INITIAL,
    deposit_list: initialStateConstant.DEPOSIT_LIST_INITIAL,
    deposit_form: initialStateConstant.DEPOSIT_FORM_INITIAL,
    workout_payment_form: initialStateConstant.WORKOUT_PAYMENT_FORM_INITIAL,
    rest_goods_form: initialStateConstant.REST_GOODS_FORM_INITIAL,
    salaries_data: initialStateConstant.SALARIES_DATA_INITIAL,
    leaderboard: initialStateConstant.LEADERBOARD_INITIAL,
    available_subscriptions_form: initialStateConstant.AVAILABLE_SUBSCRIPTION__FORM_INITIAL,
    last_booking_form: initialStateConstant.LAST_BOOKING_FORM_INITIAL,
    children_form: initialStateConstant.CHILDREN_FORM_INITIAL,
    child_form: initialStateConstant.CHILD_FORM_INITIAL,
    reviews: initialStateConstant.REVIEWS_INITIAL,
    counterparties: initialStateConstant.COUNTERPARTIES_INITIAL,
    change_user_password_form: initialStateConstant.CHANGE_USER_PASSWORD_FORM_INITIAL,
    debt_list: initialStateConstant.DEBT_LIST_INITIAL,
    cash: initialStateConstant.CASH_INITIAL,
    cash_form: initialStateConstant.CASH_FORM_INITIAL,
    price_for_subscription: [],
    invoices: initialStateConstant.INVOICES_INITIAL,
    send_receipt_form: initialStateConstant.SEND_RECEIPT_FORM_INITIAL,
    slugs: [],
    other_settings: initialStateConstant.OTHER_SETTINGS_INITIAL,
    change_user_email_form: initialStateConstant.CHANGE_USER_EMAIL_FORM_INITIAL,
    services: initialStateConstant.SERVICES_INITIAL,
    services_form: initialStateConstant.SERVICES_FORM_INITIAL,
    services_settings: initialStateConstant.SERVICES_SETTINGS_INITIAL,
    master_form: initialStateConstant.MASTER_FORM_INITIAL,
    specialization_form: initialStateConstant.SPECIALIZATION_FORM_INITIAL,
    service_form: initialStateConstant.SERVICE_FORM_INITIAL,
    master_schedule_form: initialStateConstant.MASTER_SCHEDULE_FORM_INITIAL,
    master_services_form: initialStateConstant.MASTER_SERVICES_FORM_INITIAL,
    remove_data_form: initialStateConstant.REMOVE_DATA_FORM_INITIAL,
    master_schedule_times_form: initialStateConstant.MASTER_SCHEDULE_TIMES_FORM_INITIAL,
    master_copy_schedule_days: initialStateConstant.MASTER_COPY_SCHEDULE_DAYS_INITIAL
};